/**
 * Copies text to a user's clipboard
 * @param {string} text
 * @param {function} callback
 * @returns {string}
 */
export default function(text, callback) {
  if (!text) return

  // Create a temporary textarea with the text to copy from
  const tempInput = document.createElement("textarea")
  tempInput.classList.add("visually-hidden")
  tempInput.value = text

  // Add it to the page
  document.body.appendChild(tempInput)

  // Copy the text
  tempInput.select()
  document.execCommand("copy")

  // Remove it from the page
  document.body.removeChild(tempInput)

  if (callback) callback()

  return text
}
